import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('BulkChangeStatusController', BulkChangeStatusController);

    /** @ngInject */
    function BulkChangeStatusController(
        $rootScope,
        $scope,
        $state,
        $stateParams,
        CompanyFactory,
        CompaniesFactory,
        toastr,
        ngDialog
    ) {
        var vm = this;

        init();

        function init() {
            vm.save = save;
            vm.canSave = canSave;
            vm.issueIds = $scope.ngDialogData.batchItems.split(",").map(id => Number(id));
            vm.companyId = angular.copy($scope.ngDialogData.company);
            vm.selectedStatus = null;
            vm.selectedEmployee = null;

            getCompanySettings();
            getCompanyEmployees();
        }

        function getCompanySettings() {
            CompanyFactory.readCompany().then(function (response) {
                vm.statusesList = [
                    { name: 'Przyjęto', value: 'inprogress' },
                    { name: 'Przekazano', value: 'forwarded' },
                    { name: 'Zrealizowano', value: 'fixed' },
                ];

                CompaniesFactory.readCompanies(vm.companyId).then(function (
                    companySettings
                ) {
                    if (companySettings.data.estimate_status) {
                        vm.statusesList.push({
                            name: 'Kosztorys',
                            value: 'estimate',
                        });
                    }
                    if (companySettings.data.invoiced_status) {
                        vm.statusesList.push({
                            name: 'Zafakturowano',
                            value: 'invoiced',
                        });
                    }
                });
            });
        }

        function getCompanyEmployees() {
            const getDisplayName = (contractor) => {
                if (contractor.first_name && contractor.last_name) {
                    return contractor.first_name + ' ' + contractor.last_name;
                } else {
                    return contractor.email;
                }
            };
            const attachDisplayName = employee => (
                {...employee, displayName: getDisplayName(employee)}
            );

            CompaniesFactory.readEmployees(vm.companyId, {
                page_size: 1000,
            }).then(response => {
                vm.contractorsFromBackend = (
                    response.data.results.map(attachDisplayName)
                );
            });
        }

        function canSave() {
            switch (vm.selectedStatus) {
                case 'forwarded':
                    return !!vm.selectedEmployee;
                case 'inprogress':
                case 'fixed':
                case 'estimate':
                case 'invoiced':
                    return true;
                default:
                    return false;
            }
        }

        function save() {
            if (!canSave()) {
                return;
            }
            const employee = vm.selectedEmployee && {
                userId: vm.selectedEmployee.user,
            }
            CompaniesFactory.bulkChangeStatus(
                vm.companyId, vm.selectedStatus, vm.issueIds, employee
            ).then(() => {
                toastr.success('Status został zmieniony.');
                $state.reload('company_employee.issue_list');
                ngDialog.close();
            }).catch(response => {
                toastr.error(`${response.statusText} (${response.status})`);
            });
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/company_issue_list/bulk_actions/change-status/change-status.controller.ts